import { useAuth } from "@hooks";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * For pre-authentication pages that you should not be able to go to after authentication.
 * Redirects to the `next` query param if present, otherwise to /dashboard.
 */
export function useRedirectAuthenticatedUsers() {
  const navigate = useNavigate();
  const { isUserAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next");

  useEffect(() => {
    if (!isUserAuthenticated) {
      return;
    }

    if (next) {
      navigate(next);
      return;
    }

    navigate("/dashboard");
  }, [isUserAuthenticated, navigate, next]);

  return null;
}
